<template>
  <div class="search" :style="{transform:`translateY(${openSearch?0:'100%'})`}">
    <div class="search-header">
      <div style="padding-right:10px;" class="flex-center">
        <div style="font-size:16px;color:#2B2B2B;max-width:65px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;" @click="openCitySelected">{{cityNameFormat(searchCity)}}</div>
        <van-icon name="arrow-down" size="12" style="margin-left:5px;" />
      </div>
      <div style="flex: 1;">
        <van-field ref="search" left-icon="search" clearable v-model="searchValue" placeholder="请输入地址搜索" @input="handleQuery" @clear="handleQuery" />
      </div>
      <div style="padding-left:10px;" @click="cancelSearch">{{form.province?'取消':'地图'}}</div>
    </div>
    <div class="location-permission" v-show="showLocationPermission">
      <div style="display: flex;align-items: center;flex: 1;">
        <div>定位权限未开启</div>
        <!-- <van-tag plain type="warning" @click="goSystemAppSetting">去开启</van-tag> -->
        <van-button 
          round 
          type="warning" 
          size="mini"
          plain square
          class="go-system-app-setting"
          @click="goSystemAppSetting"
        >去开启</van-button>
      </div>
      <van-icon name="cross" size="12" color="#85807B" style="flex-shrink: 0;" @click="showLocationPermission = false" />
    </div>
    <div class="search-list" v-show="searchValue">
      <div class="flex-sa" style="font-size: 16px;color: #4776E3;padding-bottom: 10px;border-bottom:1px solid #F5F5F5">
        <div style="padding-bottom: 15px 0;" class="flex-center" @click="handleOpenSearch(false)">
          <span class="iconfont" style="font-size:13px;margin-right:5px;">&#xe62e;</span>
          <span>地图选址</span>
        </div>
        <div style="padding-bottom: 15px 0;" @click="handleShowIdentification">
          <span class="iconfont" style="font-size:13px;margin-right:5px;">&#xe630;</span>
          <span>地址识别</span>
        </div>
      </div>
      <div class="search-main">
        <div class="search-item" v-for="(item,index) in list" :key="index" @click="searchItemClick({ item , historyRecord: 'getQueryParams' })">
          <van-icon name="location" color="#F1892E" size="20px" class="location-icon" />
          <div class="search-item-content">
            <div class="--title">{{item.title}}</div>
            <div class="--address">{{item.address}}</div>
          </div>
          <div class="prompt" v-if="item.prompt">{{item.prompt}}</div>
        </div>
        <van-empty
          image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
          description="暂无数据"
          image-size="50px"
          v-show="!list.length&&!listLoading&&isWeiXinLogin()&&$route.query.locationPhoneLat&&$route.query.locationPhoneLng"
        />
        <van-loading color="rgba(0,0,0,.5)" size="40px" v-show="listLoading" class="loading" />
      </div>
    </div>
    <div class="search-list" v-show="!searchValue">
      <div class="search-header" style="padding: 0;">
        <div style="font-size: 14px;font-weight: bold;">历史记录</div>
        <div style="font-size: 12px;color: #A4A4A4;" @click="handleClearHistory">清空</div>
      </div>
      <div class="search-main">
        <div 
          class="search-item" 
          v-show="isDefaultLocation&&!listLoading&&!isWeiXinLogin()" 
          @click="handleRegainPhoneLocation"
        >
          <van-icon name="location" color="#F1892E" size="20px" class="location-icon" />
          <div class="search-item-content">
            <div class="--title">选择当前位置</div>
            <div class="--address">需要获取您的地址位置权限</div>
          </div>
          <div class="prompt"></div>
        </div>
        <div 
          class="search-item" 
          v-show="(!isWeiXinLogin()&&!isDefaultLocation&&!listLoading)" 
          @click="positionPhoneClick"
        >
          <van-icon name="location" color="#F1892E" size="20px" class="location-icon" />
          <div class="search-item-content">
            <div class="--title">{{locationPhoneInfo.title}}</div>
            <div class="--address">{{locationPhoneInfo.detailedAddress}}</div>
          </div>
          <div class="prompt">当前位置</div>
        </div>
        <div class="search-item" v-for="(item,index) in searchHistoryRecordList" :key="index" @click="searchItemClick({ item , historyRecord: 'setQueryParams' })">
          <van-icon name="location" color="#F1892E" size="20px" class="location-icon" />
          <div class="search-item-content">
            <div class="--title">{{item.title}}</div>
            <div class="--address">{{item.address}}</div>
            <div style="display: flex;align-items: center;flex-wrap: wrap;">
              <div class="--real-name">{{item.realName}}</div>
              <div class="--phone-number">{{item.phoneNumber}}</div>
              <div class="--phone-number">{{ item.remark }}</div>
            </div>
          </div>
          <div class="prompt" v-if="item.prompt">{{item.prompt}}</div>
        </div>
        <van-empty
          image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
          description="暂无数据"
          image-size="50px"
          v-show="!searchHistoryRecordList.length&&!listLoading&&isWeiXinLogin()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Field , Toast , Icon , Empty , Loading , Button , Tag } from 'vant';
import { mapSuggestion , geocoder } from '@/api/dispatch/components/search-list.js';
import permission from '@/utils/permission.js'

export default {
  name:'dispatch-search-list',
  inject:["myModal","isWeiXinLogin"],
  props:['map','openSearch','mapCenterInfo','showIdentification','locationPhoneInfo','queryParams'],
  components:{ 
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [Empty.name]: Empty,
    [Loading.name]: Loading,
    [Button.name]: Button,
    [Tag.name]: Tag,
   },
  data(){
    return {
      searchList:[],
      form:{},
      searchValue:'',
      // searchCity:'',  //搜索方位(城市)  例如:深圳
      listLoading:false,
      list:[],
      searchItemActive:{},  //当前点击的搜索项
      mapPanendDisabled:true,  //控制平移结束方法是否执行
      queryTimer:null,  //防抖定时器
      searchHistoryRecordList:[],  //搜索历史记录列表
      showLocationPermission: false,  //显示定位权限未开启
    }
  },
  created(){
    document.addEventListener("visibilitychange",this.handleVisibilityChange);
  },
  beforeDestroy(){
    document.removeEventListener("visibilitychange",this.handleVisibilityChange);
  },
  computed:{
    searchCity(){
      return this.mapCenterInfo.city?this.mapCenterInfo.city:''
    },
    isDefaultLocation(){
      return (
        (this.locationPhoneInfo.latitude == '22.543099' && this.locationPhoneInfo.longitude == '114.057868') 
        || !this.locationPhoneInfo.latitude || !this.locationPhoneInfo.longitude
      );
    }
  },
  watch:{
    openSearch:{
      handler(nVal,oVal){
        if(nVal&&nVal!=oVal) {
          this.searchValue = '';
          this.list = [];
          let searchHistoryRecord = localStorage.getItem("searchHistoryRecord");
          searchHistoryRecord = this.$test.jsonString(searchHistoryRecord) ? JSON.parse(searchHistoryRecord) : {};
          let searchHistoryRecordList = searchHistoryRecord[this.$route.query.userName] ? searchHistoryRecord[this.$route.query.userName] : [];
          searchHistoryRecordList = searchHistoryRecordList.filter(item => item.province && item.city && item.detailedAddress && item.latitude && item.longitude && item.address)
          this.searchHistoryRecordList = searchHistoryRecordList;
        }
      },
      immediate:true
    },
    isDefaultLocation:{
      handler(newBool,oldBool) {
        if(newBool === oldBool) return;
        this.showLocationPermission = this.isWeiXinLogin() ? false : newBool;
      },
      immediate: true
    }
  },
  methods:{
    // 检测程序前后台切换及息屏
    handleVisibilityChange(){
      if(!document.hidden)this.handleRegainPhoneLocation({ notMessage:true });
    },
    // 打开城市选择列表
    openCitySelected(){
      this.$bus.emit('showCitySelected',true);
    },
    mountPanend(map){
      this.$emit('togglePanend',false)
      map.on('panend',this.mapPanend);
    },
    handleQuery(){
      if(this.queryTimer) {
        clearTimeout(this.queryTimer);
        this.queryTimer = null;
      }
      this.queryTimer = setTimeout(() => {
        this.getList();
      }, 200);
    },
    /** 获取搜索列表 */
    getList(){
      if(!this.searchValue) {
        this.list = [];
        return Promise.resolve(this.list);
      };
      return new Promise(async(resolve,reject)=>{
        try {
          this.list = [];
          this.listLoading = true;
          let { centerCity } = await this.getMapCenter({notSetInfo:true});
          let { data } = await mapSuggestion({keyword:this.searchValue,region:centerCity,policy:1});
          this.list = data;
          this.listLoading = false;
          return Promise.resolve(data);
        } catch (error) {
          this.listLoading = false;
          return Promise.reject(error);
        }
      })
    },
    setLocationPhoneInfo(){
      if(['province','city','detailedAddress','title','latitude','longitude'].every(key=>this.locationPhoneInfo[key])){
        if(this.isDefaultLocation) return Promise.reject();
        return Promise.resolve({
          address:this.locationPhoneInfo.detailedAddress,
          city:this.locationPhoneInfo.city,
          district:this.locationPhoneInfo.district,
          location:{
            lat:this.locationPhoneInfo.latitude,
            lng:this.locationPhoneInfo.longitude
          },
          province:this.locationPhoneInfo.province,
          title:this.locationPhoneInfo.title,
          prompt:'当前位置',
        })
      }else return Promise.reject();
    },
    async getMapCenter(){
      try {
        let { lat , lng } = this.map.getCenter();
        let { result } = await geocoder({location:`${lat},${lng}`,get_poi:1,poi_options:'policy=2'});
        if(!result.pois||!result.pois.length) return Promise.reject({centerCity:''});
        else return Promise.resolve({centerCity:result.address_component.city});
      } catch (error) {
        return Promise.reject(error);
      }
  },
    /** 打开搜索框 */
    handleOpenSearch(boolean){
      this.$emit('update:openSearch',boolean)
    },
    /** 地图平移结束 */
    mapPanend(){
      if(this.mapPanendDisabled) return;
      this.$emit('update:mapCenterInfo',{
        province:this.searchItemActive.province,  //省
        city:this.searchItemActive.city,  //市
        district:this.searchItemActive.district,  //区
        detailedAddress:this.searchItemActive.address,  //详细地址
        title:this.searchItemActive.title,  //标题
        latitude:this.searchItemActive.location.lat,
        longitude:this.searchItemActive.location.lng,
        adcode: this.searchItemActive.adcode
      })
      this.$emit('update:getCenterLoading',false);
      this.mapPanendDisabled = true;
    },
    // 搜索项的点击
    searchItemClick({ item , historyRecord }) {
      if(item.location.lat == this.mapCenterInfo.latitude && item.location.lng == this.mapCenterInfo.longitude) return this.handleOpenSearch(false);
      this.searchItemActive = item
      this.mapPanendDisabled = false;
      this.map.panTo(new window.TMap.LatLng(item.location.lat, item.location.lng));
      this.$emit('update:getCenterLoading',true);
      this.handleOpenSearch(false);
      this.$emit('update:getCenterLoading',true);
      if(historyRecord) {
        // historyRecord: setQueryParams | getQueryParams
        this.handleSearchHistoryRecordAdd({ item , historyRecord });
      }
    },
    // 添加搜索历史记录 跟着账号走，避免同一个手机登录不同账号时历史记录一致 searchHistoryRecord = { 13012564563:[{地址信息...}] }
    handleSearchHistoryRecordAdd({ item , historyRecord }){
      try {
        let searchHistoryRecord = localStorage.getItem("searchHistoryRecord");
        searchHistoryRecord = this.$test.jsonString(searchHistoryRecord) ? JSON.parse(searchHistoryRecord) : {};
        let list = searchHistoryRecord[this.$route.query.userName] ? searchHistoryRecord[this.$route.query.userName] : [] ;
        // 清除相同的记录项
        let deleteIndex = list.findIndex(findItem=>findItem.location.lat === item.location.lat && findItem.location.lng === item.location.lng);
        ~deleteIndex ? list.splice(deleteIndex,1) : "";
        // 添加当前记录到最前面
        if(historyRecord === "getQueryParams") {
          list.unshift({
            ...item,
            realName: this.queryParams.realName,
            phoneNumber: this.queryParams.phoneNumber,
            remark: this.queryParams.remark
          });
        }else if(historyRecord === "setQueryParams") {
          list.unshift(item);
          if(item.realName || item.phoneNumber) {
            this.$emit("update:queryParams",{
              ...this.queryParams,
              realName: item.realName || "",
              phoneNumber: item.phoneNumber || "",
              remark: item.remark || "",
            })
          }
        };
        list = list.filter(item => item.province && item.city && item.detailedAddress && item.latitude && item.longitude && item.address)
        // 缓存前面二十条记录
        list = list.slice(0,20);
        searchHistoryRecord[this.$route.query.userName] = list;
        localStorage.setItem("searchHistoryRecord",JSON.stringify(searchHistoryRecord));
      } catch (error) {
        console.log("缓存失败",error);       
      }
    },
    // 清空历史记录
    handleClearHistory(){
      this.myModal({
        title:"清空历史记录?",
        confirmButtonText:"立即清空",
        confirm: () => {
          this.searchHistoryRecordList = [];
          let searchHistoryRecord = localStorage.getItem("searchHistoryRecord");
          searchHistoryRecord = this.$test.jsonString(searchHistoryRecord) ? JSON.parse(searchHistoryRecord) : {};
          searchHistoryRecord[this.$route.query.userName] = [];
          localStorage.setItem("searchHistoryRecord",JSON.stringify(searchHistoryRecord));
        }
      })
    },
    async positionPhoneClick(){
      let item = await this.setLocationPhoneInfo();
      this.searchItemClick({ item });
    },
    // 地址识别方法
    handleShowIdentification() {
      this.handleOpenSearch(false);
      this.$emit('update:showIdentification',true);
    },
    cancelSearch(){
      this.handleOpenSearch(false);
      // else uni.navigateBack({ delete: 1 });
    },
    goSystemAppSetting(){
      // permission.goSystemAppSetting();
      this.isWeiXinLogin() && window.uni.navigateBack({ delta: 1 });
      window.uni.postMessage({
        data: { pagesType: "openAppAuthorizeSetting" }
      });
    },
    // 重新获取手机定位信息
    handleRegainPhoneLocation({ notMessage }){
      this.listLoading = true;
      permission.appPermission({ iosKey:'location', androidKey:'ACCESS_FINE_LOCATION' })
      .then(PermissionResult=>{
        this.handleGetLocation()
        .then(async position => {
          let { result:geocoderResult } = await geocoder({location:`${position.lat},${position.lng}`,get_poi:1,poi_options:'policy=2'});
          this.$emit('update:locationPhoneInfo',{
            province:geocoderResult.address_component.province,  //省
            city:geocoderResult.address_component.city,  //市
            district:geocoderResult.address_component.district,  //区
            detailedAddress:geocoderResult.pois[0].address,  //详细地址
            title:geocoderResult.pois[0].title,  //标题
            latitude:geocoderResult.location.lat,
            longitude:geocoderResult.location.lng,
          });
          this.$nextTick(async()=>{
            await this.getList();
            this.listLoading = false;
          })
          // 将地图中心移动至手机当前位置
          /* this.map.panTo(new window.TMap.LatLng(position.lat, position.lng));
          this.$emit('update:mapCenterInfo',{
            province:geocoderResult.address_component.province,  //省
            city:geocoderResult.address_component.city,  //市
            district:geocoderResult.address_component.district,  //区
            detailedAddress:geocoderResult.pois[0].address,  //详细地址
            title:geocoderResult.pois[0].title,  //标题
            latitude:geocoderResult.location.lat,
            longitude:geocoderResult.location.lng,
          }) */
        }).catch(err=>{
          console.log('位置信息获取失败',JSON.stringify(err));
          this.listLoading = false;
          if(!notMessage) {
            this.$dialog.confirm({
              title:'权限提示',
              message:'请在手机中开启定位信息权限',
            }).then(()=>{
              // permission.goSystemAppSetting();
              this.goSystemAppSetting();
            }).catch(()=>{})
          }
        })
      }).catch(err=>{
        this.listLoading = false;
        console.log('位置权限开启失败',JSON.stringify(err))
        if(!notMessage) {
          this.$dialog.confirm({
            title:'权限提示',
            message:'请在手机中开启定位信息权限',
          }).then(()=>{
            // permission.goSystemAppSetting();
            this.goSystemAppSetting();
          }).catch(()=>{})
        }
      })
    },
    
  }
}
</script>

<style scoped lang="scss">
 .search {
    position: fixed !important;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    // display: none;
    flex-direction: column;
    transition: all 0.3s;
    display: flex;
  }

  .search-header {
    padding: 15px 22px;
    padding-bottom: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #FFF;
  }
  ::v-deep .search-header .van-field {
    height: 33px;
    padding: 0 10px ;
    background-color: #F7F7F7;
    border-radius: 20px;
    overflow: hidden;
    .van-field__left-icon {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .van-field__body {
      height: 100%;
    }
  }
  .location-permission {
    height: 46px;
    display: flex;
    align-items: center;
    border-radius: 4px;
    box-shadow: 0px 3px 6px 1px rgba(204,181,159,0.1);
    padding: 0 16px;
    overflow: hidden;
    font-size: 14px;
    line-height: 22px;
    color: #333;
    background-color: #FFF;
    margin: 8px 12px 0 12px;
    /* .van-tag {
      margin-left: 8px;
      height: 24px;
      padding: 0 8px;
      border-radius: 4px;
    }
    .van-tag--warning {
      color: #EC7E2E;
      border-color: #EC7E2E;
      background-color: #FFFCF5;
      &:active {
        background-color: #EC7E2E;
        color: #FFF;
      }
    } */
    .go-system-app-setting {
      border-radius: 4px;
      border-color: #EC7E2E;
      background-color: #FFFCF5;
      color: #EC7E2E;
      margin-left: 8px;
    }
    .van-icon {
      &:active {
        color: rgba(133, 128, 123, .5) !important;
      }
    }
  }
.search-list {
  flex: 1;
  margin: 10px 12px 0 12px;
  padding: 15px;
  padding-bottom: 0;
  border-radius: 10px;
  background: #FFF;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.search-main {
  flex: 1;
  overflow-y: auto;
}

.search-item {
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 1px solid #F5F5F5;
  .prompt {
    font-size: 13px;
    color: #A4A4A4;
    margin-left: 15px;
  }
  .location-icon {
    flex-shrink: 0;
    margin-right: 10px;
  }
  &-content {
    flex: 1;
    .--title {
      font-size: 16px;
      color: #130A01;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .--address {
      font-size: 13px;
      color: #A4A4A4;
    }
    .--real-name {
      font-size: 12px;
      color: #3D3833;
      line-height: 22px;
    }
    .--phone-number {
      font-size: 12px;
      color: #3D3833;
      line-height: 22px;
      margin-left: 6px;
    }
  }
}
  .loading {
    width: 100%;
    margin-top: 32px;
    text-align: center;
  }
</style>